/**
 * After cart AJAX (add/remove/qty), Shopify injects English section HTML.
 * On /ar-sa (Weglot subdirectory), NEVER call Weglot.switchTo — that navigates
 * to en-sa / ar-sa. Instead translate cart DOM in place via Weglot.translate().
 */
(function () {
  var retranslateTimer = null;
  var followUpTimers = [];
  var translateInFlight = false;
  var pendingRetranslate = false;
  var MAX_BATCH = 40;

  function isArabicPage() {
    if (typeof window.dptIsArabic === 'function') return window.dptIsArabic();
    var path = (window.location.pathname || '').toLowerCase();
    return (
      path.indexOf('/ar-sa') !== -1 ||
      document.documentElement.getAttribute('dir') === 'rtl' ||
      (document.documentElement.getAttribute('lang') || '').indexOf('ar') === 0
    );
  }

  function weglotLang() {
    try {
      if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
        var lang = Weglot.getCurrentLang();
        if (lang && lang !== 'en') return lang;
      }
    } catch (e) {}
    return isArabicPage() ? 'ar' : null;
  }

  function cartRoots(preferredRoot) {
    var list = [];
    if (preferredRoot && preferredRoot.nodeType === 1) list.push(preferredRoot);
    [
      document.getElementById('Cart'),
      document.getElementById('Cart-Drawer'),
      document.querySelector('.cart-drawer'),
      document.querySelector('.thb-cart-form'),
      document.querySelector('[data-dpt-gift-wrapping-section]'),
      document.querySelector('.dpt-gift-wrapping')
    ].forEach(function (el) {
      if (el && list.indexOf(el) === -1) list.push(el);
    });
    return list;
  }

  function applyCurrency(root) {
    if (typeof window.dptApplyArabicCurrency === 'function') {
      window.dptApplyArabicCurrency(root || document.body);
    }
  }

  function shouldSkipElement(el) {
    if (!el || !el.tagName) return true;
    var tag = el.tagName;
    return (
      tag === 'SCRIPT' ||
      tag === 'STYLE' ||
      tag === 'NOSCRIPT' ||
      tag === 'TEXTAREA' ||
      tag === 'CODE' ||
      tag === 'SVG' ||
      tag === 'PATH'
    );
  }

  function looksTranslatable(str) {
    if (!str) return false;
    var trimmed = String(str).replace(/\s+/g, ' ').trim();
    if (trimmed.length < 2) return false;
    // Needs Latin letters — already-Arabic / pure numbers are skipped
    if (!/[A-Za-z]/.test(trimmed)) return false;
    return true;
  }

  function collectJobs(roots) {
    var jobs = [];

    function addJob(type, target, key, value) {
      if (!looksTranslatable(value)) return;
      jobs.push({ type: type, target: target, key: key, value: value });
    }

    roots.forEach(function (root) {
      if (!root) return;

      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var parent = node.parentElement;
          if (!parent || shouldSkipElement(parent)) return NodeFilter.FILTER_REJECT;
          if (parent.closest && parent.closest('[data-wg-notranslate], .notranslate, .wg-no-translate')) {
            return NodeFilter.FILTER_REJECT;
          }
          if (!looksTranslatable(node.nodeValue)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var node;
      while ((node = walker.nextNode())) {
        addJob('text', node, null, node.nodeValue);
      }

      var attrs = ['aria-label', 'title', 'placeholder', 'value'];
      var els = root.querySelectorAll('a, button, input, textarea, [aria-label], [title], [placeholder]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (shouldSkipElement(el)) continue;
        for (var a = 0; a < attrs.length; a++) {
          var name = attrs[a];
          if (name === 'value' && el.tagName !== 'INPUT' && el.tagName !== 'BUTTON') continue;
          if (name === 'value' && el.type && el.type !== 'submit' && el.type !== 'button') continue;
          var attrVal = el.getAttribute(name);
          if (attrVal) addJob('attr', el, name, attrVal);
        }
      }
    });

    return jobs;
  }

  function applyTranslatedBatch(jobs, translations) {
    if (!translations || !translations.length) return;
    for (var i = 0; i < jobs.length; i++) {
      var translated = translations[i];
      if (translated == null || translated === '') continue;
      var job = jobs[i];
      if (!job) continue;
      if (job.type === 'text') {
        if (job.target && job.target.nodeType === 3 && looksTranslatable(job.target.nodeValue)) {
          job.target.nodeValue = translated;
        }
      } else if (job.type === 'attr' && job.target && job.key) {
        var current = job.target.getAttribute(job.key);
        if (current && looksTranslatable(current)) {
          job.target.setAttribute(job.key, translated);
        }
      }
    }
  }

  function translateBatch(jobs, lang) {
    return new Promise(function (resolve) {
      if (!jobs.length || typeof Weglot === 'undefined' || typeof Weglot.translate !== 'function') {
        resolve();
        return;
      }

      var words = jobs.map(function (job) {
        return { t: 1, w: String(job.value).replace(/\s+/g, ' ').trim() };
      });

      var settled = false;
      function done(data) {
        if (settled) return;
        settled = true;
        applyTranslatedBatch(jobs, data);
        resolve();
      }

      try {
        var result = Weglot.translate({ words: words, languageTo: lang }, done);
        if (result && typeof result.then === 'function') {
          result.then(done).catch(function () {
            done(null);
          });
        }
      } catch (e) {
        done(null);
      }
    });
  }

  function translateCartDom(preferredRoot) {
    var lang = weglotLang();
    if (!lang || typeof Weglot === 'undefined' || typeof Weglot.translate !== 'function') {
      return Promise.resolve();
    }

    var jobs = collectJobs(cartRoots(preferredRoot));
    if (!jobs.length) return Promise.resolve();

    var chain = Promise.resolve();
    for (var i = 0; i < jobs.length; i += MAX_BATCH) {
      (function (slice) {
        chain = chain.then(function () {
          return translateBatch(slice, lang);
        });
      })(jobs.slice(i, i + MAX_BATCH));
    }
    return chain;
  }

  function clearFollowUps() {
    for (var i = 0; i < followUpTimers.length; i++) {
      clearTimeout(followUpTimers[i]);
    }
    followUpTimers = [];
  }

  function runRetranslate(root) {
    if (translateInFlight) {
      pendingRetranslate = true;
      return;
    }
    translateInFlight = true;

    translateCartDom(root)
      .then(function () {
        applyCurrency(root);
      })
      .catch(function () {})
      .then(function () {
        translateInFlight = false;
        if (pendingRetranslate) {
          pendingRetranslate = false;
          runRetranslate(root);
        }
      });
  }

  /**
   * @param {Element=} root
   * @param {Object=} options
   */
  function dptWeglotRetranslate(root, options) {
    if (!isArabicPage()) return;

    options = options || {};
    var delay = typeof options.delay === 'number' ? options.delay : 50;

    clearTimeout(retranslateTimer);
    clearFollowUps();

    retranslateTimer = setTimeout(function () {
      runRetranslate(root);

      // Late GWP / free-sample refreshes inject English again after the first pass
      [400, 900, 1800].forEach(function (ms) {
        followUpTimers.push(
          setTimeout(function () {
            if (!isArabicPage()) return;
            runRetranslate(root);
          }, ms)
        );
      });
    }, delay);
  }

  window.dptWeglotRetranslate = dptWeglotRetranslate;

  function onCartDomUpdated() {
    dptWeglotRetranslate(document.body, { delay: 80 });
  }

  document.addEventListener('cart:item-added', onCartDomUpdated);
  document.addEventListener('line-item:change:end', onCartDomUpdated);
  document.addEventListener('cart:refresh', onCartDomUpdated);
  document.addEventListener('cart-drawer:open', function () {
    dptWeglotRetranslate(document.getElementById('Cart-Drawer') || document.body, { delay: 120 });
  });

  function initObserver() {
    if (!document.body || window.__dptWeglotCartObserver) return;

    var targets = [
      document.getElementById('Cart'),
      document.getElementById('Cart-Drawer'),
      document.querySelector('.cart-drawer'),
      document.querySelector('.thb-cart-form'),
      document.querySelector('[data-dpt-gift-wrapping-section]')
    ].filter(Boolean);

    if (!targets.length) return;

    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      if (translateInFlight) {
        pendingRetranslate = true;
        return;
      }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (!isArabicPage()) return;
        runRetranslate(document.body);
      }, 250);
    });

    targets.forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true });
    });

    var gw = document.querySelector('[data-dpt-gift-wrapping-section]');
    if (gw && gw.parentNode) {
      observer.observe(gw.parentNode, { childList: true, subtree: false });
    }

    window.__dptWeglotCartObserver = observer;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
